import React, {useMemo} from "react";
import CloudinaryImage from "react-cloudinary-lazy-image";
import {extractPublicIdAndCloudName} from "../utils/cloudinaryUtils";

export const ProgressiveImageLoader = ({src, width, maxWidth = null, height, blurSize = 200, style}) => {
    const {cloudName, publicId} = useMemo(() => extractPublicIdAndCloudName(src), [src]);

    return cloudName ? (
        <CloudinaryImage
            cloudName={cloudName}
            imageName={publicId}
            {...(maxWidth ? {fluid: {maxWidth}} : {fixed: {width, height}})}
            urlParams={""}
            imgFormat={false}
            quality={false}
            blurSize={blurSize}
            style={style}
        />
    ) : (
        <img className="image-place-holder" alt="place-holder" src={src} style={{...style, width, height}} />
    );
};
